import { render, staticRenderFns } from "./AlarmList.vue?vue&type=template&id=b0a95dfa&scoped=true"
import script from "./AlarmList.vue?vue&type=script&lang=js"
export * from "./AlarmList.vue?vue&type=script&lang=js"
import style0 from "./AlarmList.vue?vue&type=style&index=0&id=b0a95dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a95dfa",
  null
  
)

export default component.exports